import {
  Avatar,
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PageHeader from "components/PageHeader/Pageheader";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import ProfileForm from "./ProfileForm";
import { Fragment, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { getUserProfile } from "slices/userReducer";
import { AvatarProps } from "utils/image.util";
import { auth } from "firebase-config/firebase";
import { getAuth } from "firebase/auth";

const MyProfile = () => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  const { authReducer, userReducer }: any = useAppSelector((state) => state);
  const { submittingProfile, loadingProfile } = userReducer;
  const { loginState = { displayName: "", pic: "", email: "" } } = authReducer;
  const { displayName, pic, email } = loginState;
  const methods = useForm({
    mode: "onChange",
  });
  const dispatch = useAppDispatch();
  const watchallFields = methods.watch();
  const [updateProfilePicture, setUpdateProfilePicture] = useState("");
  const user: any = getAuth().currentUser;
  const providers = user.providerData.map(
    (provider: any) => provider.providerId
  );
  console.log(providers);
  useEffect(() => {
    if (userReducer.userProfile) {
      const {
        name,
        email,
        address_line_1,
        address_line_2,
        city,
        state,
        zipcode,
        mobile_number,
        mobile_number_verified,
        summary,
        image_url,
      }: any = userReducer.userProfile;

      const selectedIfAny: any = watchallFields;

      methods.setValue("name", selectedIfAny.name ? selectedIfAny.name : name);
      methods.setValue("email", email);
      setUpdateProfilePicture(image_url);
      setTimeout(() => {
        methods.setValue(
          "addressLine1",
          // address_line_1,
          selectedIfAny.addressLine1
            ? selectedIfAny.addressLine1
            : address_line_1
        );
      }, 1000);
      methods.setValue(
        "addressLine1",
        // address_line_1,
        selectedIfAny.addressLine1 ? selectedIfAny.addressLine1 : address_line_1
      );
      methods.setValue(
        "addressLine2",
        // address_line_2,
        selectedIfAny.addressLine2 ? selectedIfAny.addressLine2 : address_line_2
      );
      methods.setValue(
        "city",
        // city,
        selectedIfAny.city ? selectedIfAny.city : city
      );
      methods.setValue(
        "state",
        // state,
        selectedIfAny.state ? selectedIfAny.state : state
      );
      methods.setValue(
        "zipcode",
        // zipcode,
        selectedIfAny.zipcode ? selectedIfAny.zipcode : zipcode
      );

      methods.setValue("mobile_number", mobile_number);
      methods.setValue("mobile_number_verified", mobile_number_verified ?? 0);

      methods.setValue(
        "summary",
        selectedIfAny.summary ? selectedIfAny.summary : summary
      );
    } else {
      methods.setValue("mobile_number_verified", 0);
    }

    return () => methods.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReducer.userProfile]);

  useEffect(() => {
    dispatch(getUserProfile());
  }, [dispatch]);
  return (
    <FormProvider {...methods}>
      <Box>
        <PageHeader navPath="/" title="My Profile" />
        <Box p={2.5}>
          <Grid container spacing={2} alignItems="stretch">
            {!isMobileView && (
              <Grid
                item
                xs={12}
                sm={12}
                md={3}
                lg={4}
                xl={4}
                sx={{
                  backgroundColor: isMobileView ? "#fff" : "#F4F4F4",
                  px: 4,
                  py: 4,
                }}
              >
                <Typography
                  sx={{
                    fonFamily: "Inter",
                    fontSize: "20px",
                    fontWeight: 600,
                    lineHeight: "64px",
                    textAlign: "left",
                    mt: -1.5,
                  }}
                >
                  Profile details
                </Typography>
                <Box
                  sx={{ border: "1px solid #E2E2E2", backgroundColor: "#fff" }}
                >
                  <List sx={{ p: 0 }}>
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon sx={{ mr: 1 }}>
                          <Avatar
                            alt={watchallFields?.name}
                            {...AvatarProps(
                              [updateProfilePicture, pic],
                              watchallFields?.name,
                              "#eee",
                              { width: 56, height: 56 }
                            )}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={watchallFields?.name}
                          secondary={watchallFields?.email}
                          primaryTypographyProps={{
                            color: "common.black",
                            textTransform: "capitalize",
                            fontWeight: 600,
                            fontSize: "18px",
                            lineHeight: "48px",
                            marginTop: "-12px",
                          }}
                          secondaryTypographyProps={{
                            fontSize: "14px",
                            color: "#323232",
                            fontWeight: 400,
                            fontFamily: "Inter",
                            marginTop: "-12px",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    <Box sx={{ p: 2 }}>
                      {watchallFields?.summary?.length ? (
                        <Fragment>
                          <Typography
                            sx={{
                              fontFamily: "Inter",
                              fontSize: "16px",
                              fontWeight: "600",
                              lineHeight: "30px",
                              textAlign: "left",
                            }}
                          >
                            More info
                          </Typography>
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={2}
                            mt={2}
                          >
                            <img
                              alt="phone"
                              src={require("assets/img/png/phone.png")}
                              style={{ width: "24px", height: "24px" }}
                            />
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontWeight: 400,
                                lineHeight: "24px",
                                textAlign: "left",
                              }}
                            >
                              {watchallFields?.mobile_number}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            // alignItems="center"
                            spacing={2}
                            mt={2}
                          >
                            <img
                              alt="location"
                              src={require("assets/img/png/menubar/location.png")}
                              style={{ width: "24px", height: "24px" }}
                            />
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontWeight: 400,
                                lineHeight: "24px",
                                textAlign: "left",
                              }}
                            >
                              {`${watchallFields?.addressLine1} ${watchallFields?.addressLine2} ${watchallFields?.city} ${watchallFields?.state} ${watchallFields?.zipcode}`}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="column"
                            justifyContent="flex-start"
                            // alignItems="center"
                            spacing={0.55}
                            mt={2}
                          >
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontWeight: 600,
                                lineHeight: "30px",
                                textAlign: "left",
                              }}
                            >
                              About me
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontWeight: 400,
                                lineHeight: "24px",
                                textAlign: "left",
                                wordWrap: "break-word",
                              }}
                            >
                              {watchallFields?.summary}
                            </Typography>
                          </Stack>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            mt={2}
                            p={3}
                          >
                            <img
                              src={require("assets/img/png/noProfileData.png")}
                              alt="No Profile Data"
                              style={{ height: "159px", width: "75%" }}
                            />
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "26px",
                                fontWeight: 700,
                                lineHeight: "31.47px",
                                textAlign: "center",
                              }}
                            >
                              Complete Your Profile
                            </Typography>
                            <Typography
                              sx={{
                                color: "#A2A2A2",
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontWeight: 500,
                                lineHeight: "24px",
                                textAlign: "center",
                              }}
                            >
                              Completing your profile ensures that you get the
                              most out of our platform. It allows us to tailor
                              our services to your preferences and needs.
                            </Typography>
                          </Stack>
                        </Fragment>
                      )}
                    </Box>
                  </List>
                </Box>
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={9} lg={8} xl={8}>
              <ProfileForm
                updateProfilePicture={updateProfilePicture}
                setUpdateProfilePicture={setUpdateProfilePicture}
                pic={pic}
                watchallFields={watchallFields}
                methods={methods}
                submittingProfile={submittingProfile}
                loadingProfile={loadingProfile}
                isPasswordLogin={providers.includes("password")}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default MyProfile;
